'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vendor
var prevScrollPos = (0, _jquery2.default)(window).scrollTop();

var $stickyHeader = (0, _jquery2.default)(_dom2.default.stickyHeader);

var init = exports.init = function init() {
  stickyInit();
  bindUIActions();
};

var stickyInit = function stickyInit() {
  if ((0, _jquery2.default)(window).scrollTop() >= 72) {
    hideHeader();
  }
};

var hideHeader = function hideHeader() {
  if (!$stickyHeader.hasClass('is-hidden')) {
    $stickyHeader.addClass('is-hidden');
    _dom2.default.$body.addClass('is-header-hidden');
  }
  return false;
};

var showHeader = function showHeader() {
  if ($stickyHeader.hasClass('is-hidden')) {
    $stickyHeader.removeClass('is-hidden');
    _dom2.default.$body.removeClass('is-header-hidden');
  }
  return false;
};

var stickyCheck = function stickyCheck() {
  if ((0, _jquery2.default)(window).scrollTop() > prevScrollPos) {
    if ((0, _jquery2.default)(window).scrollTop() >= 72) {
      hideHeader();
    }
  } else {
    showHeader();
  }
  prevScrollPos = (0, _jquery2.default)(window).scrollTop();
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(window).on('scroll', function () {
    stickyCheck();
  });
};